module.exports = __webpack_public_path__ + "img/left-img.a3aa8f6d.png";